import React, { useState } from 'react';
import { FaFileCsv, FaSync } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { descargarLre } from '../../services/dt/dtService';
import '../../styles/pages/RRHH/DTPage.css';

/**
 * Página del módulo DT (Dirección del Trabajo)
 * Genera el CSV del Libro de Remuneraciones Electrónico (LRE) de un período para cargarlo en Mi DT
 */
const DTPage = ({ id_company }) => {
    const [generando, setGenerando] = useState(false);

    // Período a generar
    const [periodo, setPeriodo] = useState({
        anio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1
    });

    /**
     * Genera y descarga el CSV del LRE del período
     */
    const handleGenerarCSV = async () => {
        try {
            setGenerando(true);
            await descargarLre(id_company, periodo.mes, periodo.anio);
            Swal.fire('Descargado', 'Libro de Remuneraciones generado', 'success');
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        } finally {
            setGenerando(false);
        }
    };

    /**
     * Genera lista de años para el selector
     */
    const getAnios = () => {
        return [2026, 2025, 2024];
    };

    /**
     * Genera lista de meses para el selector
     */
    const meses = [
        { value: 1, label: 'Enero' },
        { value: 2, label: 'Febrero' },
        { value: 3, label: 'Marzo' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Mayo' },
        { value: 6, label: 'Junio' },
        { value: 7, label: 'Julio' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Septiembre' },
        { value: 10, label: 'Octubre' },
        { value: 11, label: 'Noviembre' },
        { value: 12, label: 'Diciembre' }
    ];

    return (
        <div className="dt-container">
            {/* Header */}
            <div className="dt-header">
                <h1><FaFileCsv /> DT - Libro de Remuneraciones Electrónico</h1>
            </div>

            {/* Sección de Generación */}
            <div className="dt-section">
                <h2>Generar CSV del período</h2>
                <div className="dt-form-grid">
                    <div className="form-group">
                        <label>Año</label>
                        <select
                            value={periodo.anio}
                            onChange={(e) => setPeriodo({ ...periodo, anio: parseInt(e.target.value) })}
                        >
                            {getAnios().map((anio) => (
                                <option key={anio} value={anio}>{anio}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Mes</label>
                        <select
                            value={periodo.mes}
                            onChange={(e) => setPeriodo({ ...periodo, mes: parseInt(e.target.value) })}
                        >
                            {meses.map((mes) => (
                                <option key={mes.value} value={mes.value}>{mes.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group form-group-button">
                        <button
                            className="btn-generar"
                            onClick={handleGenerarCSV}
                            disabled={generando}
                        >
                            {generando ? (
                                <><FaSync className="spinning" /> Generando...</>
                            ) : (
                                <><FaFileCsv /> Generar CSV</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DTPage;
